import { useAtomValue } from 'jotai';
import type { ReactNode } from 'react';
import { userAtom } from '@/stores/auth.store';
import { Header } from './components/header';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const user = useAtomValue(userAtom);
  const balance = user?.balance ?? 0;

  return (
    <div className="min-h-screen flex flex-col">
      <Header balance={balance} />
      <main className="flex-1 p-6 bg-muted/30">{children}</main>
    </div>
  );
}
